(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rb-responsive-hero-video"] && !Shopify.designMode) return;
  try {
    const rbHeroBreakpoint = window.matchMedia('(max-width: 699px)');
  const syncRbHeroSource = (video) => {
    const source = Array.from(video.querySelectorAll('source')).find((candidate) => {
      return !candidate.media || window.matchMedia(candidate.media).matches;
    });
    if (source && video.getAttribute('src') !== source.getAttribute('src')) {
      video.setAttribute('src', source.getAttribute('src'));
      video.load();
    }
  };
  const initializeRbHeroSources = () => {
    document.querySelectorAll('.rb-responsive-media video[data-rb-explicit-source]').forEach(syncRbHeroSource);
  };
  initializeRbHeroSources();
  window.addEventListener('pageshow', initializeRbHeroSources);
  document.addEventListener('shopify:section:load', initializeRbHeroSources);
  rbHeroBreakpoint.addEventListener('change', () => {
    document.querySelectorAll('.rb-responsive-media video').forEach((video) => {
      if (video.hasAttribute('data-rb-explicit-source')) {
        syncRbHeroSource(video);
      } else {
        video.load();
      }
      if (video.autoplay) {
        video.play().catch(() => {
          video.controls = true;
        });
      }
    });
  });

  let rbHeroLayoutFrame;
  const updateRbHeroLayout = () => {
    document.querySelectorAll('.rb-hero-background').forEach((hero) => {
      const offset = Math.max(0, hero.getBoundingClientRect().top + window.scrollY);
      hero.style.setProperty('--rb-hero-offset', offset + 'px');
    });
  };
  const scheduleRbHeroLayout = () => {
    cancelAnimationFrame(rbHeroLayoutFrame);
    rbHeroLayoutFrame = requestAnimationFrame(updateRbHeroLayout);
  };
  const rbHeroLayoutObserver = new ResizeObserver(scheduleRbHeroLayout);
  document.querySelectorAll('.rb-hero-background').forEach((hero) => {
    rbHeroLayoutObserver.observe(hero);
    const precedingSection = hero.closest('.shopify-section')?.previousElementSibling;
    if (precedingSection) rbHeroLayoutObserver.observe(precedingSection);
  });
  const rbHeroHeader = document.querySelector('.shopify-section--header');
  if (rbHeroHeader) rbHeroLayoutObserver.observe(rbHeroHeader);
  window.addEventListener('resize', scheduleRbHeroLayout, { passive: true });
  window.visualViewport?.addEventListener('resize', scheduleRbHeroLayout, { passive: true });
  document.addEventListener('shopify:section:load', scheduleRbHeroLayout);
  document.fonts.ready.then(scheduleRbHeroLayout);
  updateRbHeroLayout();
  } catch(e) { console.error(e); }
})();

})();
